<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <!-- Accordion -->
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <h3 class="g-color-main">My Account</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-font-size-20--md g-font-size-17 g-color-primary--hover g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17" v-html="group.items"></span> 
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    data () {
    return {
        collapseStatus: false,
        groups: [
            {
                "name": "Where can I update my account information?",
                "open": false,
                "items": "Click on the <a href='UserAccount'>My Account</a> page and on that page you can edit Login Information such as email and password, Account Information and Shipping Address, Professional Information, Forecast and Communication preferences."
            },
            {

                "name": "Can I change my Business/Participant Name?",
                "open": false,
                "items": "Users will not be able to edit their Account Number or Business/Participant name. Should you have any changes to your Business/Participant name, please contact Customer Service at support@onesight.org or (866) 385-0447. You may be required to create a separate account and complete the contract for the new Business/Practice entity."
            },
            {
                "name": "How can I cancel my account?",
                "open": false,
                "items": "Please contact Customer Service at support@onesight.org or 385-044747 to cancel your account"
            },
            {
                "name": "How and when should I update my forecast?",
                "open": false,
                "items": "We ask that you complete an estimated forecast at the time of registration, and we will ask for a revised estimate on a calendar year basis. In the interim, should you have any updates that dramatically increase or reduce your forecast, please proceed to the <a href='UserAccount'>My Account</a> page in order to edit your forecast." + 
                "<br><br>If the forecast exceeds 100 orders per year you will be asked to complete a forecast by month so that we can ensure the supply chain can accommodate the orders. Essilor Vision Foundation may inquire and audit any forecast and has the right to cap any forecasts at any time."
            },
            {
                "name": "Where can I locate the assigned lab?",
                "open": false,
                "items": "The lab assignment will be made available to you when you place an order. The lab information will be provided on the Order Confirmation, Order Summary and Track Order page. In a frame-to-come order, please plan to print the Order Summary, retain one half and return the other with the frame for manufacturing."
            }
        ]
    }
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        }, 
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// MyAccount.vue?8e6e2534